<template lang="pug">
	.display-object-tree-line(:class="{protected: isProtectedElement}" v-on:mousedown="startElementsDragDetection(element, $event)" v-on:click="processLineClick()")
		.eye.fa(v-if="!isWorld" :class=`{
				'fa-eye-slash': isElementHidden && isElementHidden(element),
				'fa-eye': !isElementHidden || !isElementHidden(element)
			}` v-on:click.stop="toggleDashboardVisibility(element)")
		.margin(:style="{width: `${element._offset * 10 + isWorld ? 10 : 0}px`}")
		.toggle.fa(:class="{'fa-angle-right': element.childs && dashboardExpanded[`${element['version_id']}-${element['screen_codename']}-${element['codename']}`] === false, 'fa-angle-down': element.childs && dashboardExpanded[`${element['version_id']}-${element['screen_codename']}-${element['codename']}`] !== false}" v-on:click.stop="toggleExpanded(element)")
		.icon.fa(:class=`{
				'fa-globe': element.type === 'global',
				'fa-cubes': element.type === 'root-container',
				'fa-folder': element.type === 'container',
				'fa-picture-o': element.type === 'image',
				'fa-font': element.type === 'text',
				'fa-pencil': element.type === 'graphics',
				'fa-video-camera': element.type === 'video',
				'fa-child': element.type === 'spine',
				'fa-film': element.type === 'sprite-animation'
			}` v-on:click.stop="selectElement(element.codename)")
		.name
			input.dynamic-name(ref="codename-input" v-if="renameMode && !isProtectedElement" :value="element._tmpCodename || element.codename" :style="{'width': `calc(330px - 35px - ${element._offset * 10}px)`}" v-on:change="renameElement($event.target.value)" v-on:blur="renameMode = false" v-on:keyup="processRenameKeyUp($event)")
			.static-name.protected-name(v-else-if="isProtectedElement") {{displayName}}
			.static-name(v-else :style="{'width': `calc(330px - 35px - ${element._offset * 10}px)`}" v-on:click="processElementCodenameClick()") {{element._tmpCodename || element.codename}}
		.options
			.option.effects(v-if="hasEffects" v-on:click.stop="openElementEffects(element.codename)")
				.fa.fa-film
			.option.events(v-if="hasEvents" v-on:click.stop="openElementEvents(element.codename)")
				.fa.fa-bell-o
</template>

<script>

	import Screen 					from './../../mixins/screen'

	import SettingControls 			from './../Settings/SettingControls.vue'

	import { Elements }				from './../../services/Elements'

	export default {
		name: 'ElementsTreeLine',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Element Animation Added",
				"Selected Element Animation Changed",
				"Selected Element Animation Removed",
				"Selected Element Emitter Added",
				"Selected Element Emitter Changed",
				"Selected Element Emitter Removed",
				"Selected Element Event Added",
				"Selected Element Event Changed",
				"Selected Element Event Removed",
				"Screen Event Added", // События сцены (root-container) - хранятся как события экрана
				"Screen Event Changed",
				"Screen Event Removed",
				"Global Event Added", // События world (global) - хранятся как глобальные события версии
				"Global Event Changed",
				"Global Event Removed",
				"Selected Version Events Loaded", // Когда делает реверт всем событиям элемента или сцены или глобальным
				"Selected Version Switched",
				"Settings Tab Changed:elements"
			],
			events: {
				"Element Changed: [parent|priority],Selected Version Element Removed,Selected Version Element Added": function(element) {

					if (this.element['version_id'] === element['version_id'] && this.element['screen_codename'] === element['screen_codename'] && this.element['codename'] === element['codename']) this.update();
					if (this.element['version_id'] === element['version_id'] && this.element['screen_codename'] === element['screen_codename'] && this.element['codename'] === element['parent']) this.update();

				}
			}
		},
		components: {
			SettingControls
		},
		props: ['element', 'selectElement', 'openElementEffects', 'openElementEvents', 'toggleDashboardVisibility', 'isElementHidden', 'toggleDashboardExpanded', 'startElementsDragging', 'dashboardExpanded'],
		computed: {
			// Глобальный элемент (world) - ссылка на настройки global
			isWorld() {

				return this.element?.type === 'global';

			},
			// Рутовый контейнер (сцена) - всегда верхний элемент экрана
			isScene() {

				return this.element?.type === 'root-container';

			},
			// Для сцены и world нельзя менять имя и перетягивать их
			isProtectedElement() {

				return this.isWorld || this.isScene;

			},
			displayName() {

				if (this.isWorld) return 'world';
				if (this.isScene) return 'scene: ' + this.element.screen_codename;

				return this.element._tmpCodename || this.element.codename;

			},
			// Ключи [screen_codename, element_codename] для поиска событий элемента в иерархии:
			// у world события глобальные ('', ''), у сцены - события экрана (коднейм экрана, '')
			eventsHierarchyKeys() {

				if (this.isWorld) return ['', ''];
				if (this.isScene) return [this.element['screen_codename'], ''];

				return [this.element['screen_codename'], this.element.codename];

			},
			// Ключи [screen_codename, element_codename] для поиска анимаций и эмиттеров элемента в иерархии:
			// у world они глобальные ('', ''), у сцены и обычных элементов - по коднейму самого элемента
			effectsHierarchyKeys() {

				if (this.isWorld) return ['', ''];

				return [this.element['screen_codename'], this.element.codename];

			}
		},
		data() {

			return {
				hasEvents: false,
				hasEffects: false,
				showed: true,
				dragDetection: null,
				doubleClickDetection: null,
				renameMode: false
			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.dragDetection) this.stopElementsDragDetection();

			});

			window.addEventListener("mousemove", e => {

				if (this.dragDetection) this.processElementsDragDetection(e);

			});

		},
		methods: {
			collectData() {

				this.version = Version.SelectedVersion;

				if (!this.version || !this.element) return;

				let versionId = this.version.id,
					eventsKeys = this.eventsHierarchyKeys,
					effectsKeys = this.effectsHierarchyKeys;

				this.hasEvents = _.size(Events.EventsByHierarchy[versionId]?.[eventsKeys[0]]?.[eventsKeys[1]] || {}) > 0;
				this.hasEffects = _.size(AnimationService.AnimationsByHierarchy[versionId]?.[effectsKeys[0]]?.[effectsKeys[1]] || {}) > 0
									|| _.size(Emitter.EmittersByHierarchy[versionId]?.[effectsKeys[0]]?.[effectsKeys[1]] || {}) > 0;

			},
			// Клик в любом месте строки world (global) или scene (root-container) - выделяем этот элемент
			processLineClick() {

				if (!this.isProtectedElement) return;

				this.selectElement(this.element.codename);

			},
			toggleExpanded(element) {

				this.toggleDashboardExpanded(element);

				this.update();

			},
			startElementsDragDetection(element, e) {
				if (this.isProtectedElement) return;

				this.dragDetection = {
					dragStartMousePosition: e.clientY
				}

			},
			processElementsDragDetection(e) {

				if (Math.abs(e.clientY - this.dragDetection.dragStartMousePosition) > 10) {

					this.startElementsDragging(this.element, this.dragDetection.dragStartMousePosition, e);

					this.dragDetection = null;

				}

			},
			stopElementsDragDetection() {

				this.dragDetection = null;

			},
			processElementCodenameClick() {

				if (!this.doubleClickDetection) {

					this.doubleClickDetection = {
						isElementSelected: Elements.SelectedElement?.codename === this.element.codename,
						timeout: setTimeout(() => {

							if (this.doubleClickDetection) {

								//Здесь мы уже понимаем что клик одинарный - нужно сделать переключение выделения учитывая то каким оно было в начале двойного клика
								if (this.doubleClickDetection.isElementSelected) this.selectElement(this.element.codename, true, true);

								this.doubleClickDetection = null;

							}

						}, 200)
					};

					//При первом клике не важно единственный он будет или двойной - нужно выделить этот объект, если он не был выделен
					if (Elements.SelectedElement?.codename !== this.element.codename) this.selectElement(this.element.codename, true, false);

				} else {

					//При двойном клике - нужно выделить этот объект, если он не был выделен
					if (Elements.SelectedElement?.codename !== this.element.codename) this.selectElement(this.element.codename, true, false);

					clearTimeout(this.doubleClickDetection.timeout);

					this.doubleClickDetection = null;

					this.renameMode = true;

					this.$nextTick(() => {

						this.$refs['codename-input'].focus();

					});

				}

			},
			processRenameKeyUp(e) {

				if (e.keyCode === 13) {

					this.renameMode = false;

				}

			},
			renameElement(newElementCodename) {

				Server.sendToServer({
					RenameElement: {
						elementId: this.element.id,
						newElementCodename: newElementCodename
					}
				});

				this.element._tmpCodename = newElementCodename;

			}

		}

	}
</script>

<style lang="sass">

	.tree, .drag-tree

		.tree-line

			.display-object-tree-line
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: left
				align-items: center
				height: 31px
				padding-left: 0
				border-top: 1px solid #343a42
				border-bottom: 1px solid #343a42
				margin-top: -1px

			&.selected .display-object-tree-line
				background-color: rgba(255, 255, 255, 0.1)

			&.dragged .display-object-tree-line
				visibility: hidden

			&.dragged.cloning .display-object-tree-line
				visibility: visible

			&.put-in .display-object-tree-line
				background-color: rgba(0, 0, 0, 0.3)

			&.dragged-over .display-object-tree-line
				background-color: rgba(255, 255, 255, 0.05)

			.eye
				display: flex
				justify-content: center
				align-items: center
				width: 30px
				height: 20px
				font-size: 11px
				padding: 0 5px
				border-right: 1px solid rgba(0, 0, 0, 0.1)

			&.hidden .eye
				opacity: 0.3

			.eye:hover
				color: #20a8d8
				opacity: 1

			&.selected .eye,
			&.hit .eye
				border-right: 1px solid rgba(255, 255, 255, 0.1)

			.toggle
				display: flex
				justify-content: center
				align-items: center
				width: 20px
				height: 20px
				font-size: 12px
				padding: 0

			&.hidden .toggle
				opacity: 0.3

			.icon
				display: flex
				justify-content: center
				align-items: center
				width: 20px
				height: 20px
				font-size: 11px
				padding-top: 2px
				opacity: 0.2

			&.selected .icon
				opacity: 0.5

			.name
				display: flex
				justify-content: left
				align-items: center
				width: 250px
				height: calc(100% - 2px)
				padding-left: 3px

				.dynamic-name
					outline: none
					color: #fff
					border: none
					border-bottom: 1px solid rgba(255, 255, 255, 0.2)
					background-color: transparent

				.static-name
					height: 100%
					padding: 3px 0

			.options
				display: flex
				margin-left: auto
				justify-content: right
				font-size: 13px
				color: var(--secondary)
				cursor: default
				width: 60px
				padding-right: 10px

				.option
					width: 25px
					height: 27px
					display: flex
					align-items: center
					justify-content: center
					opacity: 0.3
					cursor: pointer
					margin-left: 2px

					&:hover
						opacity: 1
						color: var(--blue)

					&.effects
						font-size: 12px

			&.hidden .name
				opacity: 0.3

		.tree-line

			.eye, .toggle, .icon, .name, .display-object-tree-line.protected
				cursor: pointer

	.tree.sorting, .drag-tree.sorting
		cursor: grabbing

		.tree-line

			.eye, .toggle, .icon, .name, .display-object-tree-line.protected
				cursor: grabbing

	.tree.sorting.cloning, .drag-tree.sorting.cloning
		cursor: copy

		.tree-line

			.eye, .toggle, .icon, .name, .display-object-tree-line.protected
				cursor: copy

</style>
